// extracted by mini-css-extract-plugin
export default {"articlesContainer":"AllFields_articlesContainer__MXb-J","header":"AllFields_header__AftmT"};